import { useFormContext } from 'react-hook-form';
import { LwFormMultiSelect } from 'redesign';
import { useSiteDetection } from 'shared/hooks';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { useGetCompanyPartners } from './hooks/use-get-company-partners';
import { ActionNodeFormValues } from '../action-node-editor.types';

export const ForwardToPartnersContent = () => {
  const { site } = useSiteDetection();
  const { control, setValue } = useFormContext<ActionNodeFormValues>();
  const companyPartnersQuery = useGetCompanyPartners(site);

  if (companyPartnersQuery.status !== 'success') {
    return <RenderUnsettledUI data={companyPartnersQuery} />;
  }

  return (
    <LwFormMultiSelect
      name="value"
      label="Partners"
      data-testid="action-partnerIds"
      control={control}
      options={companyPartnersQuery.data}
      onChange={(_, value) => {
        setValue('value', value);
      }}
      rules={{ required: true }}
      getOptionLabel={(option) => option.label}
      getOptionKey={(option) => option.value}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      enableSelectAll={true}
    />
  );
};
